module.exports = __webpack_public_path__ + "ee52bbd2a0bbe38020b5c30e5abecdd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/pages/HomePage2/PrintTypes/dtg.jpg
// module id = 863
// module chunks = 1